import React, { useEffect, useRef, useState } from 'react'
import PatientSummary from './PatientSummary/PatientSummary'
import PatientAuthorization from './PatientAuthorization/PatientAuthorization'
import PatientCalendarSummary from './PatientCalendarSummary/PatientCalendarSummary'
import "react-big-calendar/lib/css/react-big-calendar.css";

const PatientCalendar = (props) => {
  const [isReload, setIsReload] = useState(false);
  const scrollY = useRef(0);
  const InvalidApi = () => {
    setIsReload(!isReload);
  }

  useEffect(() => {
    const container = document.querySelector('.pateint_clender');

    const handleScroll = () => {
      scrollY.current = container.scrollTop
    };

    container.addEventListener('scroll', handleScroll);

    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className='pateint_clender d-flex gap-01 '>
      {/* <div className='col-md-2 summary'>
        <PatientSummary />
      </div> */}
      <div className='col-md-12'>
        <div className='br-left-1 br-clr'>
          <div className=''>
            <PatientAuthorization InvalidApi={InvalidApi} Reload={props} />
          </div>
          <div>
            <PatientCalendarSummary isReload={isReload} Reload={props} scrollY={scrollY}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PatientCalendar